import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IBIN, IBINRequest } from '../models/models'

export class GetCheckBinNumberParamsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/card-bin/checkBinNumberParams',
      requesterInfo,
    })
  }

  public async getCheckBinNumberParams(req: IBINRequest): Promise<IBIN[]> {
    return await this.postAsync<IBIN[]>(req)
  }
}
